import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import { createNewGroupDashboardStart } from "store/actions";
import { LayoutContext } from "App/common/hoc/Layout";
import { VALIDATION } from "consts";
import { encodeHandler } from "utils";

function CreateNewGroup(props) {
  const { lState, lMethods } = React.useContext(LayoutContext);

  const [groupName, setGroupName] = React.useState("");
  const [error, setError] = React.useState({ show: false, msg: "" });

  React.useEffect(() => {
    lMethods.updatePopupParams({
      execute: handleGroupNameChange,
      disable: groupName.length === 0 || error.show
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [groupName, error]);

  function handleGroupNameChange() {
    if (groupName === "" || groupName.trim() === "") {
      setError({ show: true, msg: VALIDATION.groups.empty });
      return;
    }
    const specialChars = /[`!@#$%^&*()+=\[\]{};':"\\|,.<>\/?~]/;
    if (specialChars.test(groupName)) {
      setError({ show: true, msg: VALIDATION.groups.specialChars });
      return;
    }

    if (
      Object.values(props.groupsObj.list).filter(
        grp =>
          grp.groupName.toLowerCase() ===
          encodeHandler(groupName.trim()).toLowerCase()
      ).length === 0
    ) {
      props.createNewGroupDashboardStart({
        groupName: encodeHandler(groupName.trim()),
        position: lState.popup.params.position
      });
      lMethods.closePopup();
    } else {
      setError({ show: true, msg: VALIDATION.groups.nameExists });
    }
  }

  function onChangeHandler(val) {
    if (val) {
      const specialChars = /[`!@#$%^&*()+=\[\]{};':"\\|,.<>\/?~]/;
      if (val.length > 20) {
        setError({ show: true, msg: VALIDATION.groups.max });
      } else {
        if (specialChars.test(val)) {
          setError({ show: true, msg: VALIDATION.groups.specialChars });
        } else {
          setError({ show: false, msg: "" });
        }
        setGroupName(val);
      }
    } else {
      setGroupName(val);
    }
  }

  return (
    <React.Fragment>
      <div className="inpt_wrp">
        <p className="lbl_txt">Name</p>
        <input
          type="text"
          className="input_text"
          value={groupName}
          onChange={e => onChangeHandler(e.target.value)}
          autoFocus
          onKeyDown={e => e.key === "Enter" && handleGroupNameChange()}
        />
        <span className="error-msg">{error.msg}</span>
      </div>
    </React.Fragment>
  );
}

function mapStateToProps(state) {
  return {
    groupsObj: state.dashboard.groups
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      createNewGroupDashboardStart
    },
    dispatch
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(CreateNewGroup);
